module.exports = __webpack_public_path__ + "static/img/tU_b@2x.11256af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/applicationDiscount/tU_b@2x.png
// module id = 24Cq
// module chunks = 69